import { Col, Container, ListGroup, Row } from "react-bootstrap";
import { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import CourseBanner from "../../components/CourseBanner/CourseBanner";
import CourseChapters from "./CourseChapters";
import { IoArrowBack } from "react-icons/io5";
import { useCoursesContext } from "../../contexts/CourseChapterProvider";

const CourseStart = () => {
  let { course } = useParams();
  const { courseData: data } = useCoursesContext();
  const navigate = useNavigate();
  
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }, [])

  return (
    <>
      <Container fluid>
        <div className="py-2">
          <Row className="g-2 g-sm-4 w-full 2xl:max-w-[1536px] 2xl:m-auto">
            <Col xs={4}>
              <div className="flex w-fit">
                <button
                  className="unac-btn-primary-fade hidden md:block"
                  onClick={() => navigate("/organizations/credentials")}
                >
                  Back
                </button>
                <button
                  className="block md:hidden button-icon"
                  onClick={() => navigate("/organizations/credentials")}
                >
                  <IoArrowBack />
                </button>
              </div>
            </Col>
            <Col xs={4}>
              <div className="h-100">
                <div className="flex-col flex-wrap min-[1380px]:flex-row m-0 align-items-center">
                  <div className="justify-start">
                    <h6 className="mb-0 fw-bold text-center page-title text-truncate">
                      {data?.title}{" "}
                    </h6>
                  </div>
                  <div className="justify-center items-center text-truncate">
                    <p className="mb-0 title-styles subtitle-styles text-center">
                      <span className="d-none d-lg-inline px-1">{" "} - </span> Mandatory -
                      {data?.chapters.length > 1 ? (
                        <> {data?.chapters.length} Chapters</>
                      ) : (
                        <> {data?.chapters.length} Chapter</>
                      )}{" "}
                    </p>
                  </div>
                </div>
              </div>
            </Col>
            <Col xs={4}>
              <div className="w-full flex justify-end">
                <Link to={`/courses/${course}/start`} className="unac-btn-secondary">
                  Take <span className="d-none d-md-inline">The</span> Test
                </Link>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
      <hr className="w-full 2xl:max-w-[1536px] 2xl:m-auto" />

      <CourseBanner url={data?.artwork} />

      <Container fluid>
        <Row className="md:justify-center w-full 2xl:max-w-[1536px] 2xl:m-auto">
          <Col sm md={10} lg={9}>
            <h4 className="my-4">{data?.description}</h4>
            <ListGroup className="mb-5">
              {data &&
                data?.chapters?.map((chapter) => (
                  <CourseChapters
                    key={chapter?.id}
                    item={chapter}
                    courseID={data?.id}
                  />
                ))}
            </ListGroup>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CourseStart;
